import React from 'react';
import * as d3 from 'd3';
import styled, { injectGlobal } from 'styled-components';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import * as MobileDetect from 'mobile-detect';
import OverviewContainer from './OverviewContainer';
import ImpactSectionContainer from './ImpactSectionContainer';
import TenprinciplesSectionContainer from './TenprinciplesSectionContainer';
import SdgsSectionContainer from './SdgsSectionContainer';
import Navbar from './Navbar';


class App extends React.Component {

  render(){
    let path = window.location.pathname;
    this.md = new MobileDetect(window.navigator.userAgent);

    injectGlobal`
      html body {
        width: 100%;
        height: 100%;
        margin: 0;
        background-color: #1e3250;
        font-size: 100%;
        overflow-y: hidden;
        overflow-x: hidden;
      }
      button:focus {outline:0;}
      div:focus {outline:0;}
      a:focus {outline:0;}
      svg {overflow:visible !important;}
    `;

    return (
      this.md.mobile() === null
        ? <Router>
            <div>
              {<Navbar /> }
              <Switch>
                <Route exact path='/' component={OverviewContainer} />
                <Route exact path='/overview' component={OverviewContainer} />
                <Route path='/tenprinciples' component={TenprinciplesSectionContainer} />
                <Route path='/sdgs' component={SdgsSectionContainer} />
                <Route path='/impact' component={ImpactSectionContainer} />
              </Switch>
            </div>
          </Router>
        :
        ''// <MobileWarning/>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App/components/App.js